import { withAuthenticationRequired } from '@auth0/auth0-react';
import SpinningLoader from '../SpinningLoader/SpinningLoader';

export const Auth0Protected = ({ component, ...props }) => {
  const Component = withAuthenticationRequired(component, {
    onRedirecting: () => (
      <div>
        <SpinningLoader />
      </div>
    ),
  });

  return <Component {...props} />;
};
